import { type FC } from 'react';
import { useDispatch } from 'react-redux';

import { formatValidationName } from '@editor2/services/elementValidationsService';
import { updateValidation } from '@editor2/services/elementValidationsActionsService';
import {
	type ResponseBoard,
	type SAQuestion,
	type SAQuestionValidation
} from '@editor2/types/pageElements';
import ConfigCard from './ConfigCard';
import { EnableSwitch } from './EnableSwitch';
import { InfoTooltip } from './InfoTooltip';
import { Threshold } from './Threshold';
import { ValidationRejoinders } from './ValidationRejoinders';

interface Props {
	element: SAQuestion | ResponseBoard;
	validation: SAQuestionValidation;
	validationIndex: number;
	courseId: number;
}

export const NonExactMatchValidation: FC<Props> = ({
	element,
	validation,
	validationIndex,
	courseId
}) => {
	const dispatch = useDispatch();

	return (
		<ConfigCard
			title={formatValidationName(validation.name)}
			enabled={validation.enabled}
			key={`non-exact-match-${validationIndex}`}
			override={validation.element_override}
			setOverride={() =>
				dispatch(
					updateValidation(
						element,
						{ ...validation, element_override: !validation.element_override },
						validationIndex,
						courseId
					)
				)
			}>
			<div className="parametersBlock">
				<div className="parameters">
					<span>Threshold:</span>
					<Threshold
						element={element}
						validation={validation}
						validationIndex={validationIndex}
						courseId={courseId}
					/>
					<InfoTooltip validationName={validation.name} />
				</div>
				<EnableSwitch
					element={element}
					validation={validation}
					validationIndex={validationIndex}
					courseId={courseId}
				/>
			</div>
			<ValidationRejoinders
				element={element}
				validation={validation}
				validationIndex={validationIndex}
				courseId={courseId}
			/>
		</ConfigCard>
	);
};
